export default __webpack_public_path__ + "static/media/Playlist-orange.7d1eb943.svg";